import { FC, useMemo, useState } from "react";
import { OptionList } from "../../../helpers/helpers";
import ImageSprite from "../../ImageSprite/ImageSprite";
import SearchSprite from "../../Inputs/SearchInput/Img/serch_input_sprite.svg";

import "./SearchBarMultiSelect.scss";

export type MultiSelectIdsHandler = (ids: number[]) => void;

interface Props {
    label: string;
    placeholder?: string;
    options: OptionList;
    selectedIds: number[];
    onChange: MultiSelectIdsHandler;
}

const SearchBarMultiSelect: FC<Props> = ({
    label,
    placeholder,
    options,
    selectedIds,
    onChange,
}) => {
    const [filterText, setFilterText] = useState("");

    const filteredOptions = useMemo(() => {
        if (!filterText) return options;
        const q = filterText.toUpperCase();
        return options.filter((o) => o.name.toUpperCase().includes(q));
    }, [options, filterText]);

    const toggle = (id: number) => {
        const next = selectedIds.includes(id)
            ? selectedIds.filter((selected) => selected !== id)
            : [...selectedIds, id];
        onChange(next);
    };

    const resetFilter = () => setFilterText("");

    return (
        <div className="search_bar_multi_select">
            <div className="form_control">
                <div className="select_checkbox_list">
                    <div className="select_checkbox_list__caption unSelectable">
                        <input
                            value={filterText}
                            type="text"
                            className="form_control__input"
                            placeholder={placeholder ?? label}
                            onChange={(e) => setFilterText(e.target.value)}
                        />
                        {filterText && (
                            <button
                                type="button"
                                className="action_button action_button__clean"
                                onClick={resetFilter}
                                aria-label="Clear filter"
                            >
                                <ImageSprite
                                    iconSprite={`${SearchSprite}#clean`}
                                />
                            </button>
                        )}
                        <div className="select_checkbox_list__caption_counter">
                            {selectedIds.length + "/" + options.length}
                        </div>
                    </div>

                    <div className="select_checkbox_list__popup">
                        <div className="select_checkbox_list__popup_container">
                            {filteredOptions.map((option, id) => {
                                const checked = selectedIds.includes(option.id);
                                return (
                                    <li
                                        className={`select_checkbox_list__option ${checked ? "selected" : ""}`}
                                        key={option.id}
                                        onClick={() => toggle(option.id)}
                                    >
                                        <div className="select_checkbox_list__option_content">
                                            <div className="select_checkbox_list__option_label">
                                                {option.name}
                                            </div>
                                            <input
                                                id={String(id)}
                                                className="select_checkbox_list__option_checkbox"
                                                checked={checked}
                                                name="optionState"
                                                type="checkbox"
                                                readOnly
                                            />
                                        </div>
                                    </li>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchBarMultiSelect;
